import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import state from './state';
import mutations from './mutations';
import getters from './getters';

import FilterIndexStore from './stores/filter-index/index';
import SearchStore from './stores/search/index';
import HolidaySearchStore from './stores/holiday-search/index';
import CheckoutStore from './stores/checkout/index';
import BrochureRequestStore from './stores/brochure-request/index';
import AccountStore from './stores/account/index';
import ToursByPriceStore from './stores/tours-by-price/index';

export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {
    'filter-index': FilterIndexStore,
    search: SearchStore,
    holidaySearch: HolidaySearchStore,
    checkout: CheckoutStore,
    brochureRequest: BrochureRequestStore,
    account: AccountStore,
    toursByPrice: ToursByPriceStore,
  }
});